import { useContext } from "react";
import AnalyticsContext from "../contexts/analytics/AnalyticsContext.js";

export const useAnalytics = () => {
  const context = useContext(AnalyticsContext);
  if (context === null) {
    throw new Error("useAnalytics must be used within an AnalyticsProvider");
  }
  return context;
};

export default useAnalytics;
